import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=42cbe5b2&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&"
export * from "./detail.vue?vue&type=script&lang=ts&"
import style0 from "./detail.vue?vue&type=style&index=0&id=42cbe5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cbe5b2",
  null
  
)

export default component.exports